<!-- Note Main Content Component -->
<div class="note-main-content">
  <!-- Name Input (Create/Edit Mode) -->
  @if (mode !== 'view') {
    <div class="note-name-section">
      <input type="text" class="note-name-input" [formControl]="noteNameControl" placeholder="Enter note name"
        [attr.aria-label]="'Note name'" [class.has-error]="noteNameControl.invalid && noteNameControl.touched"
        autocomplete="off">
      @if (noteNameControl.invalid && noteNameControl.touched) {
        <div class="note-name-error">
          <span class="error-text">Note name is required</span>
        </div>
      }
    </div>
  }

  <!-- Scrollable Content -->
  <div class="note-content-scrollable">
    <!-- Description Section -->
    <div class="note-description-section">
      <div class="section-header">
        <h3 class="section-title">
          <mat-icon class="title-icon">description</mat-icon>
          Description
        </h3>
        <button mat-icon-button class="edit-button" (click)="onEditDescription()" type="button">
          <mat-icon>edit</mat-icon>
        </button>
      </div>

      <div class="description-box">
        <!-- Target div for mentions (contenteditable) -->
        <div #descriptionTarget id="noteDescriptionTarget" [attr.contenteditable]="mode !== 'view' ? 'true' : 'false'"
          class="description-textarea" [class.readonly]="mode === 'view'" [attr.aria-label]="'Note description'"
          [attr.data-placeholder]="mode !== 'view' ? 'Describe the note in detail... (Use @ to mention team members)' : ''"
          (blur)="onDescriptionChange($event)" (input)="onDescriptionInput($event)" (keyup)="onDescriptionKeyup($event)"
          style="text-align: left; direction: ltr;">
        </div>
      </div>
    </div>

    <!-- Tabs -->
    <div class="note-tabs-section">
      <mat-tab-group [(selectedIndex)]="activeTabIndex" (selectedIndexChange)="onTabChange($event)"
        animationDuration="200ms">

        <!-- Details Tab (View & Edit Modes) -->
        @if (!hideDetailsCommentsHistory) {
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="tab-label">
                <mat-icon class="tab-icon">info</mat-icon>
                <span class="tab-label-text">Details</span>
              </span>
            </ng-template>
            <div class="tab-content-wrapper">
              <ng-content select="[details-tab]"></ng-content>
            </div>
          </mat-tab>
        }

        <!-- Attachments Tab -->
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="tab-label">
              <mat-icon class="tab-icon">attach_file</mat-icon>
              <span class="tab-label-text">Attachments</span>
              @if (attachmentsCount > 0) {
                <span class="tab-count">{{ attachmentsCount }}</span>
              }
            </span>
          </ng-template>
          <div class="tab-content-wrapper">
            <ng-content select="[attachments-tab]"></ng-content>
          </div>
        </mat-tab>

        <!-- Comments Tab (Edit/View Mode Only) -->
        @if (!hideDetailsCommentsHistory) {
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="tab-label">
                <mat-icon class="tab-icon">comment</mat-icon>
                <span class="tab-label-text">Comments</span>
                @if (commentsCount > 0) {
                  <span class="tab-count">{{ commentsCount }}</span>
                }
              </span>
            </ng-template>
            <div class="tab-content-wrapper">
              <ng-content select="[comments-tab]"></ng-content>
            </div>
          </mat-tab>
        }

        <!-- History Tab (View/Edit Mode Only) -->
        @if (!hideDetailsCommentsHistory) {
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="tab-label">
                <mat-icon class="tab-icon">history</mat-icon>
                <span class="tab-label-text">History</span>
                @if (historyCount > 0) {
                  <span class="tab-count">{{ historyCount }}</span>
                }
              </span>
            </ng-template>
            <div class="tab-content-wrapper">
              <ng-content select="[history-tab]"></ng-content>
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>
</div>

<!-- Custom Mention Dropdown (Portal to body with fixed positioning) -->
@if (showMentionDropdown) {
  <div class="custom-mention-dropdown-portal">
    <div class="custom-mention-dropdown"
      [style.top.px]="mentionDropdownTop"
      [style.left.px]="mentionDropdownLeft">
      <!-- Loading State -->
      @if (isMentionsLoading) {
        <div class="mention-loading">
          <mat-spinner diameter="20"></mat-spinner>
          <span>Searching...</span>
        </div>
      }
      <!-- User List -->
      @if (!isMentionsLoading && mentions.length > 0) {
        <div class="mention-list">
          @for (user of mentions; track user; let i = $index) {
            <div class="mention-item"
              [class.active]="i === selectedMentionIndex"
              (click)="selectMention(user)"
              (mouseenter)="selectedMentionIndex = i">
              <app-profile-avatar
                [fullName]="user.full_name"
                [profileUrl]="$any(user.profile_image)?.url || ''"
                widthSize="32px"
                heightSize="32px">
              </app-profile-avatar>
              <div class="mention-user-info">
                <div class="mention-user-name">{{user.full_name}}</div>
              </div>
            </div>
          }
        </div>
      }
      <!-- No Results -->
      @if (!isMentionsLoading && mentions.length === 0) {
        <div class="mention-no-results">
          <mat-icon>search_off</mat-icon>
          <span>No users found</span>
        </div>
      }
    </div>
  </div>
}